import { ZAttrMeta } from "./ZAttrMeta";

/**
 * Фильтрует атрибуты, которые доступны к просмотру в таблицах.
 * Исключает сложные типы данных, которые не должны отображаться в колонках таблиц.
 *
 * @param attrs - Массив атрибутов для фильтрации
 * @returns Отфильтрованный массив атрибутов, доступных к просмотру
 */
export const filterViewableAttrs = (attrs: ZAttrMeta[]): ZAttrMeta[] =>
  // Исключаем тип "list", так как это сложные данные, которые не должны показываться в таблице
  // См. комментарии в buildClassColumns и safeAttrValues
  attrs.filter(({ type }) => type.name !== "list");
